import { HelperCore } from "@/common/dependencies";

const BASE_ICONS = {
  txt: 'https://p3.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/common-icon.png',
  pdf: 'https://p2.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/pdf-icon.png',
  doc: 'https://p1.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/word-icon.png',
  xls: 'https://p4.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/excel-icon.png',
  ppt: 'https://p3.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/ppt-icon.png',
  video: 'https://p0.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/video-icon.png',
  img: 'https://p5.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/img-icon.png',
  audio: 'https://p2.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/audio-icon.png',
  // 暂时未启用的其它icon
  // url: 'https://p1.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/url-icon.png',
  // code: 'https://p4.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/code-icon.png',
  // chat: 'https://p4.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/chat-icon.png',
};

export const IMG_ICONS = 'https://p5.ssl.qhimg.com/d/inn/040389186ddc/upload_icon/img-icon.png';

export const FILE_ICONS = {
  ...BASE_ICONS,
  docx: BASE_ICONS.doc,
  xlsx: BASE_ICONS.xls,
  pptx: BASE_ICONS.ppt,
  // 视频类型
  mp3: BASE_ICONS.audio,
  m4a: BASE_ICONS.audio,
  mp4: BASE_ICONS.video,
};

export const IMG_FILE_ICONS = {
  jpg: BASE_ICONS.img,
  jpeg: BASE_ICONS.img,
  png: BASE_ICONS.img,
  webp: BASE_ICONS.img,
};

export const ALL_FILE_ICONS = {
  mp3: BASE_ICONS.audio,
  m4a: BASE_ICONS.audio,
  mp4: BASE_ICONS.video,
  ...FILE_ICONS,
  ...IMG_FILE_ICONS,
};

export const ACCEPT_FILE_TYPE = [
  '.txt',
  '.pdf',
  '.doc',
  '.docx',
  '.xls',
  '.xlsx',
  '.ppt',
  '.pptx'
];

export const ACCEPT_IMG_TYPE = [
  '.png',
  '.jpg',
  '.jpeg',
  '.webp',
  //'.svg'
];

export const ACCEPT_MEDIA_TYPE = [
  '.mp3',
  '.m4a',
  '.mp4',
];

const BASE_KNOWLEDGE_REFERER = {
  pdf : {
    color : "#A52A17",
    text : "PDF",
  },
  txt : {
    color : "#000000",
    text : "TXT",
  },
  doc : {
    color : "#006AFF",
    text : "DOC",
  },
  xls : {
    color : "#000000",
    text : "XLSX",
  },
  others : {
    color : "#000000",
    text : "",
  },
}
export const KNOWLEDGE_REFERER = {
  ...BASE_KNOWLEDGE_REFERER,
  docx: BASE_KNOWLEDGE_REFERER.doc,
  xlsx: BASE_KNOWLEDGE_REFERER.xls,
};
export const MAX_KNOWLEDGE_DISPLAY_COUNT = 10;
export const MAX_FILE_DISPLAY_COUNT = 6;

export const FILE_TYPE = {
  doc : 1,
  image : 2,
  media : 3,
}
export const getFileType = (file) => {
  if(!file){
    return "";
  }
  const fileName = file.originalName || file.url;
  let ext = HelperCore.getFileNameExt(fileName);
  if(!ext){
    return "";
  }
  ext = `.${ext}`.toLocaleLowerCase();
  if(ACCEPT_FILE_TYPE.includes(ext)){
    return FILE_TYPE.doc;
  }
  if(ACCEPT_IMG_TYPE.includes(ext)){
    return FILE_TYPE.image;
  }
  if(ACCEPT_MEDIA_TYPE.includes(ext)){
    return FILE_TYPE.media;
  }
}